import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import EntityInterface from 'common/types/entities/EntityInterface'
import React from 'react'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { useUpdateProp } from '../hooks/useUpdateProps'
import DeviceAppearanceNew from '../options/DeviceAppearance/DeviceAppearanceNew'
import HtmlAttrId from '../options/HtmlAttrId'

type OfferThankYouOrderSummarySettingsNewProps = {
  entity: EntityInterface
  defaultEntity?: EntityInterface
}

function OfferThankYouOrderSummarySettingsNew({
  entity,
  defaultEntity,
}: OfferThankYouOrderSummarySettingsNewProps) {
  const { isMobile } = useDeviceModeContext()
  const updateProp = useUpdateProp(entity)
  return (
    <>
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        defaultMargin={
          isMobile ? defaultEntity?.mobileMargin : defaultEntity?.margin
        }
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
        withoutHorizontalLine
      />
      <DeviceAppearanceNew entity={entity} />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default OfferThankYouOrderSummarySettingsNew
